<template>
  <div class="about">
    <h1>Politics Simulator</h1>
  </div>
</template>
